"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Index = void 0;
const _1 = require(".");
class Index {
    type = _1.HashTypes.pbkdf2;
    opts;
    make;
}
exports.Index = Index;
//# sourceMappingURL=pbkdf2.js.map